import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import MarqueeTapes from "../components/MarqueeTapes";
import StatsCounter from "../components/StatsCounter";
// import Testimonials from "../components/Testimonials"; // hidden for now
import Results from "../components/Results";
import Services from "../components/Services";
import Founder from "../components/Founder";
import Pricing from "../components/Pricing";
import Faq from "../components/Faq";
import ContactForm from "../components/ContactForm";
import Booking from "../components/Booking";
import Footer from "../components/Footer";
import CursorDot from "../components/CursorDot";

export default function Landing() {
  return (
    <main style={{ background: "#EBEBEB" }}>
      <CursorDot />
      <Navbar />
      <Hero />
      <MarqueeTapes />
      <StatsCounter />
      <Results />
      <Services />
      <Founder />
      <Pricing />
      <Faq />
      <ContactForm />
      <Booking />
      <Footer />
    </main>
  );
}
